module.exports = __webpack_public_path__ + "images/services/kiln.a1dc697dd644add041f9.png";